module.exports = __webpack_public_path__ + "static/media/home-chargers-big-promise-no-hover.fdb15309.svg";